import React from 'react';
import { useGetList, useRecordContext, useTranslate } from 'react-admin';
import { allowedClickComponents, useRolePermissions } from "../../aegeon-rbac/AuthRolePermissions";
import CardWrapper from '../../aegeon/cards/CardWrapper';
import QueryField from '../../aegeon/query/QueryField';
import QueryInfiniteField from '../../aegeon/query/QueryInfiniteField';
import SiteEnergeticPerformance from './SiteEnergeticPerformance';
import SiteEnergeticPerformanceCard from './SiteEnergeticPerformanceCard';

const CardEnergeticPerformance = () => {
  const t = useTranslate();
  const [subtitle, setSubtitle] = React.useState('');

  const record = useRecordContext();
  const siteId = record?.id;

  const moment = require('moment');

  const { data } = useGetList(
    'devices',
    {
      filter: {
        siteIds: { contains: siteId },
      },
    }
  );

  const percentageOfNotA = Math.round(data?.filter(device => device.deviceType !== "waterMeter" && device.fusionedEnergyQuality !== 'A' && !device?.deposited).length / data?.filter(device => device.deviceType !== "waterMeter" && !device?.deposited).length * 100)
  const qualityWarning = percentageOfNotA > 20 ? "red" : percentageOfNotA > 5 ? "orange" : "green"

  const tooltip_text = t('sites.energetic_performance.tooltip_text') + (["red", "orange"].includes(qualityWarning) ? t('sites.energetic_performance.bad_quality_tooltip') : '') + t("sites.tooltip_percentage_not_A_prefix") + percentageOfNotA + t("sites.tooltip_percentage_not_A")


  const handleSetSubtitleCallback = (childData) => {
    if (childData) {
      setSubtitle(childData);
    }
  };

  const AdminPerfEnergeticComponent = (props) => {
    const startDate = moment().subtract(2, "months").subtract(1, "year").startOf("year")
    const endDate = moment().subtract(2, "months").subtract(1, "year").endOf("year").set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
    return (
      <CardWrapper resource="sites" type="energetic_performance" >
        <QueryField
          query_name="getSitePerformances"
          id={siteId}
          params={{
            time: { between: [startDate, endDate] },
            types: ["DEET_PCS", "DEET_PCI", "DEET_GHG", "DPE_ENEP", "DPE_GHG", "CRREM_PCS", "CRREM_GHG"]
          }}
        >
          <SiteEnergeticPerformanceCard setSubtitleCallback={handleSetSubtitleCallback} />
        </QueryField>
      </CardWrapper>
    )
  };

  const PerfEnergeticComponent = (props) => {
    const startDate = moment().subtract(2, "months").subtract(1, "year").startOf("year");
    const endDate = moment().subtract(2, "months").subtract(1, "year").endOf("year");
    return (
      <CardWrapper resource="sites" type="energetic_performance" custom_tooltip={tooltip_text} isRedWarning={qualityWarning === "red"} isOrangeWarning={qualityWarning === "orange"} subtitleCallBack={subtitle} unclickable={true} >
        <QueryInfiniteField query_name="getSiteTimeseries" params={{ time: { between: [startDate, endDate] } }}>
          <SiteEnergeticPerformance />
        </QueryInfiniteField>
      </CardWrapper>
    );
  };

  const permissionControlledComponents = {
    resource: "sites",
    elements: {
      click: {
        energetic_performance_admin: <AdminPerfEnergeticComponent />,
        energetic_performance_not_admin: <PerfEnergeticComponent />,
      },
    }
  };
  const { isLoading, permissions } = useRolePermissions();

  return (
    !isLoading && allowedClickComponents(permissions, permissionControlledComponents)
  )
};

export default CardEnergeticPerformance;

